import React from 'react'
import Product from './Product'
import { Spinner } from 'reactstrap'
import { useQuery } from 'react-apollo'
import styled from 'styled-components'
import { GET_ORDER_PRODUCTS, GET_SHOPPING_CART_PRODUCTS } from '../../../queries/products'
import { Divider } from '../../shared.styles'
import { withAuthProvider } from '../../../lib/auth'

const Container = styled.div`
  margin-bottom: 16px;
`

const querySetup = (query, variables, skip = false) => ({
  query,
  params: {
    variables,
    skip
  }
})

const getQuery = ({ orderSerno, cartId }, skip) => {
  if (orderSerno) {
    return querySetup(GET_ORDER_PRODUCTS, { orderSerno }, skip)
  }
  if (cartId) {
    return querySetup(GET_SHOPPING_CART_PRODUCTS, { cartId }, skip)
  }
  return querySetup(GET_SHOPPING_CART_PRODUCTS, null, true)
}

const ProductList = ({
  authReady,
  products,
  queryParams,
  handleProductsQuery
}) => {
  const { query, params } = getQuery(queryParams, !authReady)
  const { data, loading, error } = useQuery(query, params)

  React.useEffect(() => {
    if (data) {
      const { getShoppingCartProducts = [], getOrderProducts = [] } = data
      const allProducts = [...getShoppingCartProducts, ...getOrderProducts]
      handleProductsQuery(allProducts)
    }
  }, [data, handleProductsQuery])

  if (loading) return <div><Spinner color='secondary' /> Loading Products</div>
  if (error) return (<div className='mb-4'>Products could not be loaded</div>)

  return products.length > 0 && (
    <Container>
      <h4>Products:</h4>
      {products.map(({ description, amount, id }, index) => {
        return (
          <div key={id}>
            <Product
              index={index}
              label={description}
              value={amount}
            />
            {
              index % 2 || products.length === 1
                ? null
                : <Divider />
            }
          </div>
        )
      })}
    </Container>
  )
}

export default withAuthProvider(ProductList)
